import React from "react";
import { useDndContext } from "@dnd-kit/core";

interface PageBlockDraggableProps {}

const CSS_CLASS_NAME = "c-page-block-draggable";

export const PageBlockDraggable = (_: PageBlockDraggableProps): JSX.Element => {
    const { active } = useDndContext();

    const blockData = active?.data?.current;
    const blockContent = blockData?.blockContent || "";

    return (
        <div className={CSS_CLASS_NAME}>
            <div className={`${CSS_CLASS_NAME}__container`}>
                <div className={`${CSS_CLASS_NAME}__container__content`}>
                    {blockContent}
                </div>
            </div>
        </div>
    );
};
